import React from 'react';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';

export default class NewClientProjectItem {
  constructor(item) {
    if (item === undefined) {
      this.ProjectId = '';
      this.ProjectName = '';
      this.ClientName = '';
      this.StartDate = '';
      this.EndDate = '';
      this.OfficeName = '';
      this.ServiceType = '';
      this.ProjectManagerName = '';
      this.OpportunityId = '';
      this.OpportunityName = '';
      this.ServiceId = '';
      this.ServiceName = '';
      this.BillingCurrency = '';
      this.Contact = '';
      //this.ReimbursementType = '';
      this.ShopCountInCycle = '';
      this.Comments = '';
      this.IsWaveLinkingEnabled = false;
      return;
    }

    this.ProjectId = item.projectId;
    this.ProjectName = item.projectName;
    this.ClientName = item.clientName;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.OfficeName = item.officeName;
    this.ServiceType = item.serviceType;
    this.ProjectManagerName = item.projectManagerName;
    this.OpportunityId = item.opportunityId;
    this.OpportunityName = item.opportunityName;
    this.OpportunityDisplayName = `${item.opportunityId} - ${item.opportunityName}`;
    this.ServiceId = item.serviceId;
    this.ServiceName = item.serviceName;
    this.ServiceDisplayName = `${item.serviceId} - ${item.serviceName}`;
    this.BillingCurrency = item.billingCurrency;
    this.Contact = item.contact;
    //this.ReimbursementType = item.reimbursementType;
    this.ShopCountInCycle = item.shopCountInCycle;
    this.Comments = item.comments;
    this.IsWaveLinkingEnabled = item.isWaveLinkingEnabled;
  }

  static displayedInList = 'Name';

  static NameOfTheIdField() {
    return 'ProjectId';
  }

  static nameOfTheItemDetailList() {
    return 'Project';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['StartDate', 'EndDate'];

  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    return 'Project Details';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Project ID',
        orderById: 'ProjectId',
        data: NewClientProjectItem.idFunction,
      },
      { label: 'Project', orderById: 'ProjectName', data: 'ProjectName' },
      { label: 'Start Date', orderById: 'StartDate', data: 'StartDate' },
      { label: 'End Date', orderById: 'EndDate', data: 'EndDate' },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName' },
      { label: 'Service Type', orderById: 'ServiceType', data: 'ServiceType' },
      { label: 'Project Manager', orderById: 'ProjectManagerName', data: 'ProjectManagerName' },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path='new_projects'
        tooltipText={item.ProjectId}
        isFigmaStyle={true}
        text={item.ProjectId}
        keyValuePairs={[
          { key: 'SelectedOfficeId', value: '' },
          { key: 'ProjectIdOrName', value: item.ProjectId },
        ]}
      />
    );
  }
}
